import { createContext } from 'react';
import type { Dashboard, DashboardLayoutItem, DashboardWidgetConfig, DashboardSettings, DashboardVisibility } from './widgets/types';

export interface DashboardState {
  dashboard: Dashboard | null;
  isEditing: boolean;
  isDirty: boolean;
  isSaving: boolean;
  isLoading: boolean;
  error: string | null;
  draftLayout: DashboardLayoutItem[];
  draftWidgets: DashboardWidgetConfig[];
  draftSettings: DashboardSettings;
  draftVisibility: DashboardVisibility;
  draftTitle: string;
  draftDescription: string;
}

export interface DashboardContextValue extends DashboardState {
  loadDashboard: (id: string) => Promise<void>;
  enterEditMode: () => void;
  cancelEdit: () => void;
  saveDashboard: () => Promise<boolean>;
  /** Debounced auto-save for widget config changes outside edit mode */
  scheduleAutoSave: () => void;
  updateLayout: (layout: DashboardLayoutItem[]) => void;
  addWidget: (widget: DashboardWidgetConfig, size: { width: number; height: number }) => void;
  removeWidget: (widgetId: string) => void;
  updateWidgetConfig: (widgetId: string, config: Record<string, unknown>) => void;
  updateWidgetTitle: (widgetId: string, title: string) => void;
  updateWidgetShowTitle: (widgetId: string, showTitle: boolean) => void;
  updateLayoutItem: (
    widgetId: string,
    patch: Partial<Pick<DashboardLayoutItem, 'x' | 'y' | 'width' | 'height'>>,
  ) => void;
  updateSettings: (patch: Partial<DashboardSettings>) => void;
  updateVisibility: (visibility: DashboardVisibility) => void;
  updateTitle: (title: string) => void;
  updateDescription: (description: string) => void;
}

export const DashboardCtx = createContext<DashboardContextValue | null>(null);
